import { useContext } from 'react';
import { DynamicFormDto } from '@hqo/dynamic-forms-sdk/types';
import { FormDefinitionDto } from './form-definition-dto.context';

export const useFormDefinitionDto = (): DynamicFormDto => {
  return useContext(FormDefinitionDto);
};
